/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import Step from './Step'
import HeroWithImage from './HeroWithImage'

export default class BppHomepage {
  private json: any
  public readonly disclaimer: string
  public readonly heading: string
  public readonly instructions: string
  public readonly steps: Step[]
  public readonly hero: HeroWithImage

  constructor (json: any) {
    this.json = json
    this.disclaimer = json.disclaimer
    this.heading = json.heading
    this.instructions = json.instructions
    this.steps = json.steps.map(Step.of)
    this.hero = json.hero?.length ? HeroWithImage.of(json.hero[0]) : HeroWithImage.empty()
  }

  static of (json: any): BppHomepage {
    return new BppHomepage(json)
  }

  static empty (): BppHomepage {
    return new BppHomepage({
      disclaimer: '',
      heading: '',
      instructions: '',
      steps: [],
      hero: []
    })
  }
}
